import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import CommentScroller from "./Comments";
import { memorialApi } from "../misc/memorial.js";
import { useSummary } from "./hooks";
import CountUp from "react-countup";
const comments = [
  {
    username: "张三",
    comment: "这是第一条评论",
  },
  {
    username: "李四",
    comment: "这是第二条评论",
  },
  {
    username: "王五",
    comment: "这是第三条评论",
  },
  {
    username: "张三",
    comment: "这是第一条评论",
  },
  {
    username: "李四",
    comment: "这是第二条评论",
  },
  {
    username: "王五",
    comment: "这是第三条评论",
  },
  {
    username: "张三",
    comment: "这是第一条评论",
  },
  {
    username: "李四",
    comment: "这是第二条评论",
  },
  {
    username: "王五",
    comment: "这是第三条评论",
  },
  {
    username: "张三",
    comment: "这是第一条评论",
  },
  {
    username: "李四",
    comment: "这是第二条评论",
  },
  {
    username: "王五",
    comment: "这是第三条评论",
  },
  {
    username: "张三",
    comment: "这是第一条评论",
  },
  {
    username: "李四",
    comment: "这是第二条评论",
  },
  {
    username: "王五",
    comment: "这是第三条评论",
  },
  {
    username: "张三",
    comment: "这是第一条评论",
  },
  {
    username: "李四",
    comment: "这是第二条评论",
  },
  {
    username: "王五",
    comment: "这是第三条评论",
  },
  {
    username: "张三",
    comment: "这是第一条评论",
  },
  {
    username: "李四",
    comment: "这是第二条评论",
  },
  {
    username: "王五",
    comment: "这是第三条评论",
  },
  {
    username: "张三",
    comment: "这是第一条评论",
  },
  {
    username: "李四",
    comment: "这是第二条评论",
  },
  {
    username: "王五",
    comment: "这是第三条评论",
  },
  {
    username: "张三",
    comment: "这是第一条评论",
  },
  {
    username: "李四",
    comment: "这是第二条评论",
  },
  {
    username: "王五",
    comment: "这是第三条评论",
  },
];

export default function Content({ userCount }) {
  const ref = useRef(null);
  const { mutate } = useSummary();
  const [currentNum, setCurrentNum] = useState(0);
  const handleButtonClick = async () => {
    const bool = localStorage.getItem("candle");
    setCurrentNum(userCount);
    if (bool) {
      return;
    }
    try {
      const res = await memorialApi.createRip();
      if (res) {
        localStorage.setItem("candle", true);
        mutate();
      }
    } catch (e) {
      console.log(e);
    }
  };
  const [shouldAnimate, setShouldAnimate] = useState(true);

  useEffect(() => {
    if (shouldAnimate) {
      setShouldAnimate(false);
    }
  }, []);

  return (
    <main className="flex min-h-screen flex-col items-center justify-between  bg-[#0D0D0D] md:p-0 px-8 py-10">
      <div className="container mx-auto flex items-center flex-col text-white ">
        <section className="flex items-center justify-around  flex-col-reverse md:flex-row gap-10 md:py-[128px] h-[100vh]">
          <div className="text-center  mt-4 md:mt-0 min-w-[150px] translate-y-[-100px] md:translate-y-0">
            <motion.p
              // initial={{ y: 40 }}
              // whileInView={{ y: 0 }}
              // transition={{ duration: 1.5, ease: 'easeOut' }}
              className="text-xl mb-[18px] text-center"
            >
              谨此纪念
            </motion.p>
            <motion.p
              // initial={{ opacity: 0 }}
              // animate={{ opacity: 1 }}
              // transition={{ duration: 1 }}
              className="md:text-[48px] font-medium text-[32px] text-center"
            >
              陈 &nbsp;&nbsp;&nbsp; 皓
            </motion.p>
            <motion.p
              // whileInView={{
              //   opacity: [1, 0, 1],
              // }}
              // transition={{
              //   duration: 2,
              //   times: [0, 0.5, 1],
              //   repeat: Infinity,
              //   repeatType: 'reverse',
              // }}
              className="text-xl text-center text-[#FFFFFFCC]"
              style={{
                letterSpacing: "4.6px",
              }}
            >
              1976 - 2023
            </motion.p>
          </div>
          <div className="relative">
            <img src="/avatar.png" alt="haoel" width={600} height={583} />
          </div>
        </section>
        <section className="md:py-[60px]">
          <section className="md:text-[52px] text-2xl md:leading-[78px] mb-[48px] text-center mt-7 md:mt-0 font-bold">
            <div>
              <motion.p
                initial={{
                  opacity: shouldAnimate ? 0 : 1,
                  y: shouldAnimate ? 40 : 0,
                }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                className="motto"
              >
                芝兰生于深谷，不以无人而不芳
              </motion.p>
              <motion.p
                initial={{
                  opacity: shouldAnimate ? 0 : 1,
                  y: shouldAnimate ? 40 : 0,
                }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.8 }}
                className="motto"
              >
                君子修身养德，不以穷困而改志
              </motion.p>
            </div>
          </section>
          <section className="font-normal md:text-base  max-w-4xl " ref={ref}>
            <motion.div
              // initial={{ y: 80 }}
              // whileInView={{ y: 0 }}
              // transition={{ duration: 1, ease: "easeIn" }}
              className="flex flex-col gap-[24px]"
              initial={{
                opacity: shouldAnimate ? 0 : 1,
                y: shouldAnimate ? 40 : 0,
              }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 1 }}
            >
              <p className="indent-8">
                陈皓先生（网名：左耳朵耗子）的突然离世，让我们悲痛万分，然而看到有许许多多他曾经帮助或影响过的人一起缅怀他，我们又为他感到欣慰。一个人能被那么多人铭记，说明他并没有真正的离开。
              </p>
              <p className="indent-8">
                陈皓曾说过，“我很幸运出生在这个时代——第三次工业革命的时代，也很幸运选对了专业，我唯一要做的就是不要辜负这个时代。”他是这样说的，也是这样做的。
                他从云南大学计算机系毕业，先后在云南省工行、南天信息集团、Platform（中国）、汤森路透（中国）、亚马逊（中国）、阿里云等公司就职，并最终践行自己在大学就定下的目标——成立了
                <a
                  href="https://megaease.cn"
                  className="hover:underline hover:text-white"
                >
                  MegaEase
                </a>
                ，致力于为企业的高并发、高可用架构提供一整套的技术解决方案和产品，用技术去服务社会。
              </p>
              <p className="indent-8">
                他经常在自己博客（
                <a
                  href="https://coolshell.cn"
                  className="hover:underline hover:text-white"
                >
                  酷壳 coolshell.cn
                </a>
                ）上发表文章，或通过很多的平台分享有关技术研发、团队管理、职业规划等软件工程方面的心得和体会。他独到的见解和犀利的观点给很多互联网从业者以启迪和激励。
                他视野开阔，从底层内核到顶层架构设计均有深厚的技术积淀，同时不断带领他的团队接触和学习互联网行业的各种前沿技术和知识，并通过公司例会或社交媒体分享给有需要的人。
              </p>
              <p className="indent-8">
                是什么使得他不断跨出自己的舒适区，在一个个陌生的环境得到提升，并不断带动他人得以成长？答案是——理想与热爱！
                有了热爱，他才会在一个普遍认为程序员35岁就缺乏竞争力的背景下，二十几年如一日地奋斗在技术第一线，同时也享受着编程和技术所带来的快乐。有了理想，在面对创业时期的各种艰难和挫折时，他才会坚韧而又睿智的迎难而上，雷厉风行，言出法随，从不拖泥带水，带领团队不断成长。
                陈皓在青年时代喜欢摇滚，听重金属，听Sex Pistols，听Guns N’Roses
                ，也许叛逆、爱冒险、理想主义早就写在他基因之中。
              </p>
              <p className="indent-8">
                陈皓突然离我们而去，在他这短暂而灿烂的一生中，他一直不甘于平庸，不断地挑战自己的极限，越是在陌生的环境或不熟悉领域越勇于向前，在不断提升自我时获得成长。这是他的灵魂所在，对于后来人或接触过陈皓的人来说，这都将是一笔丰厚的财富。
              </p>
              <p className="indent-8">
                人生的意义是什么？可能每个人的心中都有自己的定义，而他用自己的亲身行动，为他所喜欢的行业和他人留下了许多有价值的内容。或许这就是他人生意义之所在。
              </p>
              <p className="indent-8">让我们再次致敬左耳朵陈皓！</p>
            </motion.div>
          </section>
        </section>
      </div>
      <section className="relative w-[100%]  flex justify-center md:py-[60px] my-10 md:my-0">
        <div className="w-[600px] flex items-center justify-center flex-col gap-4">
          <div className="absolute top-[45%] left-[50%] translate-x-[-50%] -translate-y-[70%]">
            <div
              className={"halo cursor-pointer"}
              onClick={handleButtonClick}
            ></div>
          </div>
          <img src="/candle.gif" alt="candle" width={270} height={270} />
          <div className="">
            <p className="text-center mb-[14px] text-[#FFFFFFFA] text-[33px] font-medium">
              <CountUp
                end={userCount || 0}
                start={
                  userCount - currentNum > 10
                    ? currentNum
                    : currentNum - 10 > 0
                    ? currentNum - 10
                    : 0
                }
              />
            </p>
            <p className="text-center text-[#FFFFFFCC] text-xs">
              缅怀陈皓先生人次
            </p>
          </div>
        </div>
      </section>
      <section className="w-full py-10 md:p-0 flex justify-center">
        <CommentScroller messages={comments} />
      </section>
      <section className="flex flex-col gap-4 items-center justify-center md:py-[89px] mt-10 md:mt-0">
        <a
          href="https://github.com/megaease/Remembering-Haoel"
          className="text-white text-[24px] hover:text-[white] hover:underline underline"
          target="_blank"
          rel="noreferrer"
        >
          追思陈皓
        </a>
        <p className="text-[#FFFFFF7A] text-sm">那些温暖的过往与回忆</p>
      </section>
    </main>
  );
}
